import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f86236a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content py-3" }
const _hoisted_2 = { class: "text-sm text-content --danger py-3" }
const _hoisted_3 = { class: "flex justify-center" }

import { onMounted, ref, watch } from 'vue'
import moment from 'moment-timezone'
import { COACH_ATTEND_MINUTE } from '@/data/room'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachLatePopup',
  props: {
  isAttend: {
    type: Boolean,
    default: false,
  },
  startTime: {
    type: [String, Date],
    default: '',
  },
},
  setup(__props) {

const props = __props

const { t } = useI18n()
const isOpen = ref(false)
const isClickConfirm = ref(false)

const open = () => {
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

const confirm = () => {
  isClickConfirm.value = true
  close()
}

const countdown = () => {
  /**
   * if coach attend do nothing
   */
  if (props.isAttend) return
  const lateTime = moment(props.startTime).add(COACH_ATTEND_MINUTE.LATE, 'minute')
  const absentTime = moment(props.startTime).add(COACH_ATTEND_MINUTE.ABSENT, 'minute')
  /**
   * student attend before late time of class or in range of late time (ex. 5-9.59 min)
   * counting waiting for coach join room
   */
  const isBeforeLateTime = moment().isBefore(lateTime)
  const isRangeOfLate = moment().isBetween(lateTime, absentTime, undefined, '[)')
  if (isBeforeLateTime || isRangeOfLate) {
    const countingAgain = setInterval(() => {
      const isAbsentTime = moment().isSameOrAfter(absentTime)
      const isRangeOfLate = moment().isBetween(lateTime, absentTime, undefined, '[)')
      if (isAbsentTime || props.isAttend) {
        close()
        clearInterval(countingAgain)
      } else if (isRangeOfLate) {
        if (isClickConfirm.value) {
          clearInterval(countingAgain)
        } else {
          open()
        }
      }
    }, 1000)
  } else {
    /**
     * student attend after absent time of class (for coach) and coach not join room
     */
    close()
  }
}

watch(
  () => props.isAttend,
  () => {
    if (props.isAttend) {
      close()
    }
  },
)

onMounted(() => {
  countdown()
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popup = _resolveComponent("Popup")!

  return (__props.startTime)
    ? (_openBlock(), _createBlock(_component_Popup, {
        key: 0,
        title: _unref(t)('coach-attend.late-title'),
        open: isOpen.value,
        onClose: confirm
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white text-base w-full ml-2",
              onClick: confirm
            }, _toDisplayString(_ctx.$t('coach-attend.late-close-btn')), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('coach-attend.late-content')) + " ", 1),
            _createVNode(_component_SvgIcon, {
              icon: "crying-face",
              height: "20"
            })
          ]),
          _createElementVNode("small", _hoisted_2, [
            _createElementVNode("i", null, "**" + _toDisplayString(_unref(t)('coach-attend.late-ps-content')), 1)
          ])
        ]),
        _: 1
      }, 8, ["title", "open"]))
    : _createCommentVNode("", true)
}
}

})